import { blockquoteVariants } from "../../components/markdown/BlockquoteBlock";
import { codeBlockVariants, codeInlineVariants, } from "../../components/markdown/CodeBlock";
import { liBlockVariants, olBlockVariants, ulBlockVariants, } from "../../components/markdown/List";
import { paragraphBlockVariants } from "../../components/markdown/ParagraphBlock";
import { preBlockVariants } from "../../components/markdown/PreBlock";
// This exports markdown styles for all components.
// It is used in the InputBar component.
export const markdownStyles = {
    blockquote: blockquoteVariants,
    codeInline: codeInlineVariants,
    codeBlock: codeBlockVariants,
    list: liBlockVariants,
    orderedList: olBlockVariants,
    paragraph: paragraphBlockVariants,
    pre: preBlockVariants,
    unorderedList: ulBlockVariants,
};
//# sourceMappingURL=styles.js.map